<template >
  <transition name="fade">
    <div class="preview_Box" v-show="isShow" @click="close">
      <div class="preview_index">{{startPosition+1}} / {{ images.length }}</div>
      <van-swipe :show-indicators="false" @change="onChange" class="swipeBox" ref="swipeBox">
        <van-swipe-item v-for="(item, index) in images" :key="index" class="swipeItem">
          <!-- <img v-lazy="item" alt="" class="swipe_image"> -->
          <van-image :src="item" class="swipe_image" lazy-load>
            <template v-slot:loading>
              <van-loading type="spinner" size="20" color="#fff" />
            </template>
          </van-image>
          <div class="upLoadMsg flexBox" v-if="upLoadMsg">
            <div class="flex_1" v-if="upLoadMsg.name">上传人：{{upLoadMsg.name}}</div>
            <div class="flex_1" v-if="upLoadMsg.date">{{upLoadMsg.date}} 上传</div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
  </transition>
</template>

<script>
export default {
  name: '',
  props: {
    
  },
  components: {

  },
  data() {
    return {
      isShow: false,
      startPosition: 0,//初始位置
      images: [],//图片列表
      upLoadMsg:null
    }
  },

  methods: {
    onChange(index) {
      this.startPosition = index;
    },
    close() {
      this.isShow = false;
      setTimeout(() => {
        this.images = [];
        // this.upLoadMsg = null;
        this.startPosition = 0;
      }, 300)
    },
  },
  mounted() {
    this.isShow = true;
    this.$nextTick(() => {
      if (this.startPosition) {
        this.$refs.swipeBox.swipeTo(this.startPosition, {
          immediate: true,
        })
        
      }
      console.log(this.upLoadMsg,this.images)
    })
  },
}
</script>

<style lang='less' scoped='scoped'>
.flexBox{display: flex;}
.flex_1{flex:1;color:#fff;font-size: 14px;}
.upLoadMsg{
  position: fixed;
  left:15px;right: 15px;
  bottom:20px;
}
.preview_Box {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;

  .preview_index {
    position: absolute;
    top: 20px;
    left: 50%;
    color: #fff;
    font-size: 14px;
    line-height: 20px;
    text-shadow: 0 1px 1px #323233;
    transform: translate(-50%, 0);
    z-index: 100;
  }
  .swipeBox {
    height: 100%;

    .swipeItem {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .swipe_image {
        max-width: 100%;
      }
    }
  }
}
.fade-enter-active {
  animation: fadeIn 0.3s ease-in-out;
}
.fade-leave-active {
  animation: fadeIn 0.3s ease-in-out reverse;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PreviewImage/index.vue